import React, {useEffect, useState} from "react";
import {getFTPSettingsNonMatched} from "../../../actions/OnBoardingActions";
import {DropDownList} from "@progress/kendo-react-dropdowns";
import {Dialog} from "@progress/kendo-react-dialogs";
import "./FTPSS3.css";
import {NavLink} from "react-router-dom";
import {Button} from "@progress/kendo-react-buttons";
import {
    CONNECTION_TYPE_OPTIONS,
    FTPEmbeddedForm,
    S3EmbeddedForm
} from "../../Pages/IdentityPipeline/IdentityPipelineSharedUtil";

const CREATE_CONN_OPTION = {text: "➕ Create new connection…", id: "__create__"};

const NONMATCHED_FTPSS3 = (props) => {
    const [pageLoader, setPageLoader] = useState(false);
    const [allNonMatchedSettings, setAllNonMatchedSettings] = useState([]);
    const [currentNonMatchConnection, setCurrentNonMatchConnection] = useState(
        {text: '', id: 0}
    );

    // current Non Match connection (default / chosen) details
    const [nonMatchedConnection, setNonMatchedConnection] = useState(
        {
            id: 0,
            connectionName: '',
            protocol: 'ftps',
            host: '',
            port: '',
            destinationDir: '',
            delimiter: '',
            transferMode: 'Passive',
            username: '',
            password: '',
        }
    );

    const [showConnDialog, setShowConnDialog] = useState(false);
    const [connFormType, setConnFormType] = useState(CONNECTION_TYPE_OPTIONS[0].id);
    const connTypeValue = CONNECTION_TYPE_OPTIONS.find((opt) => opt.id === connFormType) || CONNECTION_TYPE_OPTIONS[0];
    const onConnTypeChange = (e) => setConnFormType(e.value.id);

    const setFormikConnectionId = (id) => {
        if (props?.formik?.setFieldValue) {
            props.formik.setFieldValue("generate_nomatch_connection_id", id);
        } else if (props?.formik?.values) {
            props.formik.values.generate_nomatch_connection_id = id;
        }
    };

    const getAllSavedSettings = async (options = {}) => {
        setPageLoader(true);
        try {
            const res = await getFTPSettingsNonMatched();
            const list = Array.isArray(res?.data) ? res.data : [];
            setAllNonMatchedSettings(list);

            const {selectId, selectName} = options;
            const normalizedName = (selectName || "").trim().toLowerCase();

            let setting = null;
            if (selectId != null) {
                setting = list.find((ftpSetting) => String(ftpSetting.id) === String(selectId));
            }
            if (!setting && normalizedName) {
                setting = list.find(
                    (ftpSetting) => (ftpSetting.connection_name || "").trim().toLowerCase() === normalizedName
                );
            }
            if (!setting) {
                setting = list[0];
            }

            if (setting) {
                setCurrentNonMatchConnection({
                    text: setting.connection_name,
                    id: setting.id,
                    protocol: setting.transfer_protocol
                });
                setNonMatchedConnection(setting);
                setFormikConnectionId(setting.id);
            } else {
                setCurrentNonMatchConnection({text: '', id: 0});
                setNonMatchedConnection(null);
                setFormikConnectionId(null);
            }

            return setting || null;
        } catch (e) {
            setAllNonMatchedSettings([]);
            setCurrentNonMatchConnection({text: '', id: 0});
            setNonMatchedConnection(null);
            setFormikConnectionId(null);
            return null;
        } finally {
            setPageLoader(false);
        }
    };

    const baseConnections = (allNonMatchedSettings || []).map((item) => ({
        text: item.connection_name,
        id: item.id,
        protocol: item.transfer_protocol
    }));
    const dropdownConnections = [CREATE_CONN_OPTION, ...baseConnections];
    const hasCurrentSelection = baseConnections.some(
        (conn) => String(conn.id) === String(currentNonMatchConnection?.id)
    );
    const dropdownValue = hasCurrentSelection ? currentNonMatchConnection : null;

    const handleConnectionChange = (e) => {
        const selection = e.value;
        if (selection?.id === CREATE_CONN_OPTION.id) {
            setConnFormType(CONNECTION_TYPE_OPTIONS[0].id);
            setShowConnDialog(true);
            return;
        }
        if (!selection?.id) return;
        const setting = allNonMatchedSettings.find(
            (ftpSetting) => String(ftpSetting.id) === String(selection.id)
        );
        if (!setting) return;
        setNonMatchedConnection(setting);
        setCurrentNonMatchConnection({
            text: selection.text,
            id: selection.id,
            protocol: selection.protocol
        });
        setFormikConnectionId(selection.id);
    };

    const closeConnDialog = () => setShowConnDialog(false);

    const handleConnectionSaved = async (connectionName) => {
        await getAllSavedSettings({selectName: connectionName});
        setShowConnDialog(false);
    };


    const itemRender = (li, itemProps) => {
        const itemChildren = (
            <span
                style={{
                    // color: itemProps.dataItem.protocol === 's3' ? "blue" : "red",
                    fontSize: "14px"
                }}
            >
                {li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    useEffect( () => {
        async function fetchAllSavedSettings() {
            await getAllSavedSettings();
        }
        fetchAllSavedSettings();
    }, []);

    return (
        <>
            <div className={"connections-container-div"}>
                <div className={"ftp-settings-controls-container"}>
                    <div className={"ftp-settings-fts-row"}>
                        <div className={"fts-controls"}>
                            <div className={"existing-connections-dropdown-div"}>
                                <DropDownList
                                    data={dropdownConnections}
                                    itemRender={itemRender}
                                    textField="text"
                                    dataItemKey="id"
                                    onChange={(e) => handleConnectionChange(e)}
                                    value={dropdownValue}
                                    fillMode={"outline"}
                                    className="connection-settings"
                                    disabled={dropdownConnections.length===0}
                                    style={{fontSize:"14px"}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"non-matched-ftp-s3-button-outer-div"}>
                        <div className={"manage-connections-button-div"}>
                            <NavLink to={"/admin-settings"} className={"nav-link-to-admin"}
                                     onClick={() => sessionStorage.setItem('adminTabSelected', 2)}>
                                <Button
                                    className={"manage-conn-button"}
                                    iconClass="k-icon k-i-track-changes-enable"
                                >
                                    Manage Connections
                                </Button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            {showConnDialog && (
                <Dialog onClose={closeConnDialog} title={"Create Connection"} className="ip-dialog" width={"40vw"}>
                    <div className="ip-form connection-form">
                        <div className="ip-field w-25">
                            <span>Type</span>
                            <DropDownList
                                data={CONNECTION_TYPE_OPTIONS}
                                textField="name"
                                dataItemKey="id"
                                value={connTypeValue}
                                onChange={onConnTypeChange}
                                className="dropdown-standard"
                            />
                        </div>
                        {connFormType === "S3" && (
                            <S3EmbeddedForm
                                onBusyChange={() => {}}
                                onCancel={closeConnDialog}
                                onSaved={handleConnectionSaved}
                            />
                        )}
                        {connFormType === "FTP" && (
                            <FTPEmbeddedForm
                                onBusyChange={() => {}}
                                onCancel={closeConnDialog}
                                onSaved={handleConnectionSaved}
                            />
                        )}
                    </div>
                </Dialog>
            )}
        </>
    )
}

export default NONMATCHED_FTPSS3;